import DefaultTemplate from './DefaultTemplate'

export * from './DefaultTemplate'

export default DefaultTemplate
